import React, { useState } from "react";
import Modal from "react-modal";
import Select, { components } from "react-select";
import { TbGridDots } from "react-icons/tb";
import { HiChevronDown } from "react-icons/hi";
import { Form } from "react-bootstrap";
import styled from "styled-components/macro";
import { useFormContext } from "react-hook-form";
import { useEobContext } from "../../context/EobFormContext";

// ✅ Modal Styles
Modal.setAppElement("#root");
const modalCustomStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "30%",
    overflow: "hidden",
    borderRadius: "12px",
    padding: "20px",
  },
};

// ✅ Reusable QaErrorModal Component
const QaErrorModal = ({ isOpen, onClose }) => {
  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();

  const { jobData,onEobFormSubmit } = useEobContext();
  const qa_error_type = getValues("qa_error_type") || [];
  const options = jobData?.qa_error_types || [];

  const [isFocusedAllowedValues, setIsFocusedAllowedValues] = useState(false);
  const [filterState, setFilterState] = useState({ qa_error_type: [] });

  // ✅ Custom Dropdown Indicator
  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      {filterState?.qa_error_type?.length > 1 ? (
        <TbGridDots style={{ fontSize: "1.5em" }} />
      ) : (
        <HiChevronDown style={{ fontSize: "1.5em" }} />
      )}
    </components.DropdownIndicator>
  );

  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={false}
      onRequestClose={onClose}
      style={modalCustomStyles}
      contentLabel="QA Error Modal"
    >
      <section>
        {/* Header */}
        <TopHead>
          <Form.Label className="fw-bold clr-heading fs-5">
            Error Description
          </Form.Label>
          <span onClick={onClose} className="close-icon">
            <i className="bi bi-x-square"></i>
          </span>
        </TopHead>

        {/* Body */}
        <div className="row">
          <div className="col-lg-12 mb-3">
            <Select
              isMulti
              autoFocus
              tabSelectsValue={false}
              closeMenuOnSelect={false}
              options={options}
              className="select-search input-focus-shadow"
              classNamePrefix="select"
              placeholder="Error Type"
              menuPlacement="top"
              name="qa_error_type"
              components={{ DropdownIndicator }}
              onFocus={() => setIsFocusedAllowedValues(true)}
              onBlur={() => setIsFocusedAllowedValues(false)}
              onChange={(selected) => {
                setFilterState({ qa_error_type: selected });
                setValue(
                  "qa_error_type",
                  selected?.map((i) => i.value)
                );
              }}
              value={options.filter((i) =>
                qa_error_type.includes(i.value)
              )}
              styles={{
                container: (styles) => ({
                  ...styles,
                  borderRadius: "9px",
                }),
                control: (styles, state) => ({
                  ...styles,
                  backgroundColor: "#f5f8fa",
                  border: "none",
                  boxShadow: "none",
                  borderRadius: "10px",
                  maxHeight: state.isFocused ? "auto" : "30px",
                }),
                indicatorSeparator: (styles) => ({
                  ...styles,
                  width: "0px",
                }),
                placeholder: (styles) => ({
                  ...styles,
                  color: "black",
                  fontSize: "1rem",
                }),
                valueContainer: (styles) => ({
                  ...styles,
                  maxHeight: isFocusedAllowedValues ? "auto" : "30px",
                }),
              }}
            />
          </div>

          <div className="col-lg-12">
            <Form.Group>
              <Form.Control
                as="textarea"
                name="qa_error_type_comment"
                onChange={(e) =>
                  setValue("qa_error_type_comment", e.target.value)
                }
                className="form-control form-control-solid b-r-10"
                placeholder="Comments"
                style={{ height: "100px" }}
              />
            </Form.Group>
          </div>
        </div>

        {/* Footer */}
        <div className="d-flex justify-content-end text-right mt-2">
          <button
           onClick={()=>{onEobFormSubmit(getValues(), {type:"submit",is_qaModal:true});}}
            type="submit"
            className="qa-error-modal-btnHover btn btn-primary btnHover new-window col-lg-2"
          >
            Submit
          </button>
        </div>
      </section>
    </Modal>
  );
};

export default QaErrorModal;

// ✅ Styled Component
const TopHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  span.close-icon {
    cursor: pointer;
    font-size: 1.2rem;
  }
`;
